import { useState } from "react";
import type { ApiClient } from "../../api/client";
import type { Ride } from "../../api/types";
import { addressOf } from "../../features/orders/order-view";
import { t } from "../../i18n";
import { AppIcon } from "../AppIcon";

interface Props {
  api: ApiClient;
  ride: Ride;
  /** Couriers take their rides themselves (it goes back to Klaar), or the till assigns them. */
  self: boolean;
  onBack: () => void;
  /** In the window over the list: its title asks the question and its × goes back (Furkan, 18/10/2026). */
  inDialog?: boolean;
  onReleased: () => void;
  report: (error: unknown) => void;
}

/**
 * "Rit terugzetten" (Furkan, 08/10/2026: "als een koerier per ongeluk een rit neemt die de bedoeling niet
 * was, moet hij de rit terug kunnen zetten, zolang het niet is geleverd"): asked once, so a tap by mistake
 * does not give a ride away. On the way, the courier hears that the customer no longer sees him coming.
 */
export function ReleasePane({ api, ride, self, onBack, inDialog = false, onReleased, report }: Props) {
  const text = t.tafoApp.courier;
  const [busy, setBusy] = useState(false);
  const release = async () => {
    setBusy(true);
    try {
      await api.request("POST", `/device/rides/${ride.id}/release`);
      onReleased();
    } catch (error) {
      report(error);
      setBusy(false);
    }
  };
  return (
    <>
      {!inDialog && (
        <>
          <button type="button" className="linkbtn" onClick={onBack}>
            {t.tafoApp.waiter.back}
          </button>
          <h3>{text.releaseQuestion(ride.code)}</h3>
        </>
      )}
      <p className="proto">{addressOf(ride)}</p>
      <p className="confirm-text">{self ? text.releaseWhereSelf : text.releaseWhereTill}</p>
      {ride.departedAt !== null && <p className="ph-note bad">{text.releaseOnTheWay}</p>}
      <button type="button" className="btn primary ph-big" disabled={busy} onClick={() => void release()}>
        <AppIcon name="undo" />
        {text.releaseYes}
      </button>
      <button type="button" className="btn ph-big" disabled={busy} onClick={onBack}>
        {text.releaseNo}
      </button>
    </>
  );
}
